import { render, staticRenderFns } from "./contract-trade.vue?vue&type=template&id=16d73a48&scoped=true"
import script from "./contract-trade.vue?vue&type=script&lang=js"
export * from "./contract-trade.vue?vue&type=script&lang=js"
import style0 from "./contract-trade.vue?vue&type=style&index=0&id=16d73a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d73a48",
  null
  
)

export default component.exports